import { cn } from "@/lib/utils";

export type PillKind = "ok" | "low" | "crit" | "info" | "neutral";

interface StatusPillProps {
  kind: PillKind;
  label: string;
  compact?: boolean;
  className?: string;
}

const KIND_CLASSES: Record<PillKind, string> = {
  ok: "bg-success-soft text-success",
  low: "bg-warn-soft text-warn",
  crit: "bg-coral-soft text-coral",
  info: "bg-primary-soft text-primary",
  neutral: "bg-panel-2 text-ink-2",
};

const DOT_CLASSES: Record<PillKind, string> = {
  ok: "bg-success",
  low: "bg-warn",
  crit: "bg-coral",
  info: "bg-primary",
  neutral: "bg-muted",
};

export function StatusPill({ kind, label, compact, className }: StatusPillProps) {
  return (
    <span
      data-pill
      className={cn(
        "inline-flex items-center gap-1 rounded font-medium",
        KIND_CLASSES[kind],
        compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]",
        className,
      )}
    >
      <span data-pindot className={cn("inline-block size-1.5 rounded-full", DOT_CLASSES[kind])} />
      {label}
    </span>
  );
}
